import { render } from "./NovedadArticulo.vue?vue&type=template&id=2aa836f6&scoped=true"
import script from "./NovedadArticulo.vue?vue&type=script&lang=js"
export * from "./NovedadArticulo.vue?vue&type=script&lang=js"

import "./NovedadArticulo.vue?vue&type=style&index=0&id=2aa836f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa836f6"]])

export default __exports__